// ActionSheet.tsx
import { ActionSheetButton, IonActionSheet, IonContent, IonModal } from '@ionic/react';
import { closeOutline, cloudDownloadOutline, trashOutline } from 'ionicons/icons';
import React, { useState } from 'react';

import styles from '@/components/Actionsheets/ActionSheet.module.css';
import { PDFDownloadModalContent } from '@/components/PDFDownload/PDFDownloadModal';

import { ReportInfo } from '@/models';

interface ActionSheetProps {
  isOpen: boolean;
  onClose: () => void;
  reportInfo: ReportInfo;
  doDelete: (id: string) => void;
  showDeleteError: (error: boolean) => void;
  showPDFError: (error: boolean) => void;
  isError?: boolean;
}

export const ActionSheetReportCard: React.FC<ActionSheetProps> = ({
  isOpen,
  onClose,
  reportInfo,
  doDelete,
  showDeleteError,
  showPDFError,
  isError = false,
}) => {
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const handleDelete = () => {
    if (reportInfo.id) {
      doDelete(reportInfo.id);
    } else {
      showDeleteError(true);
    }
  };

  return (
    <>
      <IonActionSheet
        buttons={
          [
            !isError && {
              text: 'Generate PDF',
              icon: cloudDownloadOutline,
              handler: () => {
                setShowDownloadModal(true);
              },
            },
            {
              text: 'Delete',
              role: 'destructive',
              icon: trashOutline,
              handler: handleDelete,
            },
            {
              text: 'Cancel',
              icon: closeOutline,
              role: 'cancel',
            },
          ].filter(Boolean) as ActionSheetButton[]
        }
        isOpen={isOpen}
        onDidDismiss={onClose}
      />

      <IonModal className={styles.modal} isOpen={showDownloadModal} onDidDismiss={() => setShowDownloadModal(false)}>
        <IonContent className=''>
          <PDFDownloadModalContent
            PDFError={showPDFError}
            onClose={() => setShowDownloadModal(false)}
            reportInfo={reportInfo}
          />
        </IonContent>
      </IonModal>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default ActionSheetReportCard;
